import React from 'react'
import { Typography } from '@mui/material'
import { OverflowTooltipWrapper } from '../../OverflowTooltipWrapper/OverflowTooltipWrapper'

const LINE_HEIGHT = 1.5

export const DataTableText = ({
    text,
    variant = '14x400',
    color = 'figma.grayscale.textHier2',
    maxLines = 1,
}: {
    text: string
    variant?: '14x400' | '14x600' | '16x400' | '16x600'
    color?: string
    maxLines?: number
}) => (
    <OverflowTooltipWrapper title={text} placement="top-start" isMultiline={maxLines > 1}>
        <Typography
            variant={variant}
            sx={{
                color,
                overflow: 'hidden',
                width: '100%',
                ...(maxLines > 1
                    ? {
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: maxLines,
                          lineHeight: LINE_HEIGHT,
                          maxHeight: `${maxLines * LINE_HEIGHT}em`,
                          overflowWrap: 'anywhere',
                          whiteSpace: 'normal',
                      }
                    : { display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }),
            }}
        >
            {text}
        </Typography>
    </OverflowTooltipWrapper>
)

export default DataTableText
